import randomSort from '@/helpers/randomSort';
import api from '@/store/helpers/api';

const initialState = {
  list: [],
  loading: false,
  isOver: false,
  score: 0,
  isClassMode: false,
};

const getters = {
  score(state) {
    return state.score || 0;
  },
};

const actions = {
  get({ state, commit, dispatch }, { classMode, polling }) {
    if (!polling) {
      commit('LOADSTART');
    }

    let url = '/tinder/remaining';
    if (state.isOver) {
      url = '/tinder';
    }
    if (classMode) {
      url = `/tinder/class-mode/${classMode}`;
    }
    return api.get(url)
      .then((data) => {
        if (!classMode && data && data.length === 0) {
          commit('IS_OVER');
          return dispatch('get', {});
        }

        let sorted = [];

        if (classMode) {
          sorted = data.questions;
          dispatch('classMode/setScores', {
            game: 'cards',
            scores: [
              data.score_0 || 0,
              data.score_1 || 0,
              data.score_2 || 0,
              data.score_3 || 0,
            ],
          }, { root: true });
        } else {
          sorted = data.sort(randomSort);
        }

        if (!polling) {
          commit('SET', sorted);
        }
        return sorted;
      })
      .finally(() => {
        commit('LOADEND');
      });
  },
  answer({ commit, dispatch, state }, {
    id,
    success,
    points,
    classMode,
  }) {
    if (classMode) {
      return dispatch('classMode/answer', {
        success,
        points,
        game: 'cards',
      }, { root: true });
    }

    if (state.isOver) {
      return false;
    }

    commit('ADD_SCORE', points || 0);

    // Don't show loader, since it's an async request
    return api.post('tinder/answer', {
      id,
      success,
      points,
    });
  },
  pop({ commit }) {
    commit('POP');
  },
  reset({ commit }) {
    commit('RESET');
  },
};

const mutations = {
  LOADSTART(state) {
    state.loading = true;
  },
  LOADEND(state) {
    state.loading = false;
  },
  IS_OVER(state) {
    state.isOver = true;
  },
  SET(state, list) {
    state.score = 0;
    state.list = list;
  },
  POP(state) {
    state.list.pop();
  },
  ADD_SCORE(state, points) {
    state.score += points;
  },
  RESET(state) {
    state.list = [];
    state.loading = false;
    state.isOver = false;
    state.score = 0;
    state.isClassMode = false;
  },
};

// Export store
export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
